/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
 */

import {ApplicationRef, ComponentFactoryResolver, Injectable, Injector, Type} from '@angular/core';
import {Observable} from 'rxjs';
import {FcAgUtilsService} from '../fc-ag-services/fc-ag-utils.service';
import {FcAgContextHolderComponent} from './fc-ag-context-holder.component';
import {FcAgContextMenuComponent, FcAgContextMenuOptions} from './fc-ag-context-menu.component';
import {FcAgContextComponent} from './fc-ag-context.component';

/**
 * Common utils for Angular.
 */
@Injectable({
    providedIn: 'root'
})
export class FcAgContextService {

    private fcAgContextHolder: FcAgContextHolderComponent;
    
    /**
     * Constructor for service.
     *
     * @param resolver Component Factory Resolver.
     * @param applicationRef Component Reference.
     * @param injector Component Injector.
     * @param fcAgUtilsService FcAgUtilsService.
     */
    constructor(
        private resolver: ComponentFactoryResolver,
        private applicationRef: ApplicationRef,
        private injector: Injector,
        private fcAgUtilsService: FcAgUtilsService
    ) {}

    /**
     * Show context.
     *
     * @param component Dialog component instance.
     * @param event Click event.
     * @param data Extend data.
     * @returns Observable.
     */
    showContext(component: Type<FcAgContextComponent>, event: any, data?: any): Observable<any> {
        if (!this.fcAgContextHolder) {
            this.fcAgContextHolder = this.fcAgUtilsService.createHolderComponent(
                FcAgContextHolderComponent,
                this.resolver, this.applicationRef, this.injector);
        }
        return this.fcAgContextHolder.addModal(component, event, data);
    }

    /**
     * Show context menu.
     *
     * @param event Click event.
     * @param options Extend data.
     * @returns Observable.
     */
    showContextMenu(event: any, options: FcAgContextMenuOptions): Observable<any> {
        return this.showContext(FcAgContextMenuComponent, event, {
            options: options
        });
    }
}